<template>
  <div class="main-page-container">
    <div class="main-page-content">
      <medium-title>
        {{ mainTitle }}
      </medium-title>
      <div class="text-container">
        <div class="text-content"
             v-for="(item, index) in mainParagraph" :key="index">
          <main-title v-if="item.title"
                      :weight="'bold'"
                      :font-family="'Verdana'">
            {{ item.title }}
          </main-title>
          <main-title :font-family="'Verdana'">
            {{ item.paragraph }}
          </main-title>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MainTitle from "@/components/shared/text/MainTitle.vue";
import BigTitle from "@/components/shared/text/BigTitle.vue";
import MediumTitle from "@/components/shared/text/MediumTitle.vue";

export default {
  name: "PolicyPage",
  components: {MediumTitle, BigTitle, MainTitle},
  data() {
    return {
      mainTitle: "Политика конфиденциальности \n" +
          "и защиты информации",
      mainParagraph: [
        {
          paragraph: 'Оставляя данные на сайте, Вы соглашаетесь с Политикой конфиденциальности и защиты информации.\n'
        },
        {
          title: '\nЗащита данных',
          paragraph: '\nАдминистрация сайта https://avea-basis.ru/ (далее Сайт) не может передать или раскрыть информацию, предоставленную пользователем (далее Пользователь) при регистрации и использовании функций сайта третьим лицам, кроме случаев, описанных законодательством страны, на территории которой пользователь ведет свою деятельность.\n'
        },
        {
          title: '\nПолучение персональной информации',
          paragraph: '\nДля коммуникации на сайте пользователь обязан внести некоторую персональную информацию. Для проверки предоставленных данных, сайт оставляет за собой право потребовать доказательства идентичности в онлайн или офлайн режимах.\n'
        },
        {
          title: '\nИспользование персональной информации',
          paragraph: '\nСайт использует личную информацию Пользователя для обслуживания и для улучшения качества предоставляемых услуг. Часть персональной информации может быть предоставлена банку или платежной системе, в случае, если предоставление этой информации обусловлено процедурой перевода средств платежной системе, услугами которой Пользователь желает воспользоваться. Сайт прилагает все усилия для сбережения в сохранности личных данных Пользователя. Личная информация может быть раскрыта в случаях, описанных законодательством, либо когда администрация сочтет подобные действия необходимыми для соблюдения юридической процедуры, судебного распоряжения или легального процесса необходимого для работы Пользователя с Сайтом. В других случаях, ни при каких условиях, информация, которую Пользователь передает Сайту, не будет раскрыта третьим лицам.\n'
        },
        {
          title: '\nКоммуникация',
          paragraph: '\nПосле того, как Пользователь оставил данные, он получает сообщение, подтверждающее его успешную регистрацию. Пользователь имеет право в любой момент прекратить получение информационных бюллетеней воспользовавшись соответствующим сервисом в Сайте.\n'
        },
        {
          title: '\nСсылки',
          paragraph: '\nНа сайте могут содержаться ссылки на другие сайты. Сайт не несет ответственности за содержание, качество и политику безопасности этих сайтов. Данное заявление о конфиденциальности относится только к информации, размещенной непосредственно на сайте.\n'
        },
        {
          title: '\nБезопасность',
          paragraph: '\nСайт обеспечивает безопасность учетной записи Пользователя от несанкционированного доступа.\n'
        },
        {
          title: '\nУведомления об изменениях',
          paragraph: '\nСайт оставляет за собой право вносить изменения в Политику конфиденциальности без дополнительных уведомлений. Нововведения вступают в силу с момента их опубликования. Пользователи могут отслеживать изменения в Политике конфиденциальности самостоятельно.'
        }
      ],
    }
  }
}
</script>

<style scoped lang="scss">
  .main-page-container {
    height: var(--calc-height);
    overflow-y: scroll;
    .main-page-content {
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      row-gap: 60px;
      max-width: var(--main-max-width);
      padding: 32px var(--var-padding);
      .text-content {
        white-space: pre-wrap;
      }
    }
  }
</style>